import React from 'react';
import {Styles} from '../../../../../config/design/styles';
import { withStyles } from '@material-ui/core/styles';
import {Translate} from "../../../../../config/Translate";
import {withRouter} from "react-router-dom";
import { withSnackbar } from 'notistack';
import AppAnimate from "../../../../components/AppAnimate";
import AppCard from "../../../../components/layouts/components/AppCard";
import Grid from "@material-ui/core/Grid/Grid";
import AppCardLoaderFields from "../../../../components/Skeletons/AppCardLoaderFields";
import EditAttributesRoundedIcon from '@material-ui/icons/EditAttributesRounded';
import IconButton from "@material-ui/core/IconButton/IconButton";
import {List, ListItem, ListItemIcon, ListItemText} from "@material-ui/core";
import axios from "axios";
import {defaultVariabls} from "../../../../../config";
import {setStore} from "trim-redux";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction/ListItemSecondaryAction";
import {languages} from "../../../../../config/values";
import CheckCircleRoundedIcon from '@material-ui/icons/CheckCircleRounded';
import HighlightOffRoundedIcon from '@material-ui/icons/HighlightOffRounded';
class ChooseVariables extends React.Component {

    state = {
        table:[],
        id:this.props.id,
        loading:true,
    };
    componentDidMount(){
        this.loadData();
    }
    async loadData(){
        let loginToken = localStorage.getItem('ACT');
        if(loginToken !== null){
            let config = {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${loginToken}`
                }
            };
            await axios.get(`${defaultVariabls.url}/categories/translateTable/${this.state.id}`, config)
                .then(response => {
                    this.setState({
                        table:response.data,
                        loading:false,
                    })

                }).catch(error => {
                    console.log(error.response)
                    this.setState({
                        loading:false,
                        removeLoading:false
                    })
                })
        }else {
            setStore({
                isAuth : false,
                user : null,
            });
        }
    }
    classes = this.props.classes;
    render(){
        let {table,loading} = this.state;
        return (
                <>
                    {
                        loading ?
                            <AppCardLoaderFields/>
                            :
                            <List dense>
                                {
                                    languages.map((item,index) => (
                                        <ListItem key={index}>
                                            <ListItemText
                                                primary={item}
                                            />
                                            <ListItemSecondaryAction>
                                                    {
                                                        table.indexOf(item) > -1 || item === "en" ?
                                                                <CheckCircleRoundedIcon style={{color: "#15dd1b"}}/>
                                                            :
                                                                <HighlightOffRoundedIcon style={{color: "#999"}}/>
                                                    }
                                            </ListItemSecondaryAction>
                                        </ListItem>
                                    ))
                                }


                            </List>
                    }
                </>

        );
    }
}

export default withSnackbar(withRouter(withStyles(Styles)(ChooseVariables)));